import { createContext, useContext } from 'react';
import { useForm } from './form-context';
export const PanoramaContext = createContext(undefined);
export function usePanorama() {
    const context = useContext(PanoramaContext);
    if (context === undefined) {
        throw new Error('usePanorama must be used within a PanoramaProvider');
    }
    const panorama = context.panorama;
    const { namespace } = useForm();
    return {
        transaction: (name)=>({
                start: ()=>panorama?.transaction(name).start({
                        namespace
                    }),
                finish: ()=>panorama?.transaction(name).finish({
                        namespace
                    })
            }),
        reportError: (error, tags)=>panorama?.errorMonitor().reportError(error, {
                tags: {
                    namespace,
                    ...tags
                }
            }),
        reportWarning: (message, data)=>panorama?.logger().warn(message, {
                namespace,
                ...data
            })
    };
}

//# sourceMappingURL=panorama-context.js.map